<template>
  <div>
    <label v-if="label">Cliente:</label>
    <e-select v-if="modal" :holder="holder" :custom_option="custom_option" :name="name" route="clientesList"
      :reload="reload" v-model="cliente_id" modal="cliente" />
    <e-select ref="select" v-else :custom_option="custom_option" :holder="holder" :name="name"
      route="clientesList" v-model="cliente_id" />
    <modal title="Cadastro de cliente" size="md" id="cliente" form="clienteForm" btn_save v-if="modal">
      <cliente-form @updated="update" />
    </modal>
  </div>
</template>

<script>
import clienteForm from "../clientes/forms/clienteForm.vue";
export default {
  name: "clientesSelect",
  components: { clienteForm },
  props: {
    label: true,
    name: { type: String, default: "cliente_id"},
    holder: { type: String, default: "Pesquisar cliente" },
    value: Number,
    modal: Boolean,
    custom_option: Object,
  },
  data() {
    return {
      reload: false,
      cliente_id: this.value,
    };
  },
  watch: {
    cliente_id(newValue) {
      this.$emit("input", newValue);
    },
    value(newVal) {
      this.cliente_id = newVal;
      if (!this.cliente_id && this.$refs.select.searchText) {
        this.$refs.select.searchText = null;
      }
    },
  },
  methods: {
    update(value) {
      this.reload = true;
      this.cliente_id = value;
      setTimeout(() => {
        this.reload = false;
      }, 1000);
    },
  },
};
</script>
